import React, { useMemo } from 'react';
import { TableDocumentList } from '@ibinder/ui-common-core';

import { TableWrapper } from '../../../../styles/common';
import { GeneralPrintProps, TableHeaderPropName } from './GeneralPrint.types';
import {
  getTableHeaders,
  getTableData,
  getAllData,
  convertToDefault
} from './GeneralPrint.helpers';
import { formatDataId } from '../../../../helpers/format';
import { unsafeGet } from '../../../../helpers/unsafeGet';

export const GeneralPrint: React.FC<GeneralPrintProps> = ({
  type,
  printProvider,
  printSettings,
  dataKey,
  updateManually
}) => {
  const action = (
    propName: TableHeaderPropName,
    id: string,
    value?: any
  ): void => {
    switch (propName) {
      case 'default':
        updateManually((prev) => ({
          ...prev,
          [dataKey]: {
            ...prev[dataKey],
            [convertToDefault(type)]: id
          }
        }));
        break;
      case 'enabled':
        const newFormatGroup = printSettings[dataKey][type]?.find(
          (fg) => fg?.id === id
        );
        if (value) {
          updateManually((prev) => ({
            ...prev,
            [dataKey]: {
              ...prev[dataKey],
              [type]: [...prev[dataKey][type], newFormatGroup]
            }
          }));
        } else {
          updateManually((prev) => ({
            ...prev,
            [dataKey]: {
              ...prev[dataKey],
              [type]: prev[dataKey][type]?.filter((fg) => fg?.id !== id)
            }
          }));
        }
        break;
    }
  };

  const data = useMemo(
    () => ({
      default:
        unsafeGet(printProvider, [dataKey, convertToDefault(type)]) ||
        unsafeGet(printSettings, [dataKey, convertToDefault(type)]),
      rows: formatDataId(unsafeGet(printProvider, [dataKey, type]))
    }),
    [printProvider, printSettings, dataKey, type]
  );
  const allData = useMemo(
    () => getAllData(type, unsafeGet(printSettings, [dataKey, type])),
    [printSettings, dataKey, type]
  );
  const headers = useMemo(
    () => getTableHeaders(type, action),
    [type, dataKey, printSettings]
  );
  const tableData = useMemo(
    () => getTableData(data, headers, allData),
    [data, headers, allData]
  );

  return (
    <TableWrapper borderTop>
      <TableDocumentList
        setSelectedIds={null}
        selectedIds={[]}
        headers={headers}
        documentQuery={tableData}
        sortBy={[]}
        onSort={undefined}
        metadataElements={[]}
        rowAction={undefined}
      />
    </TableWrapper>
  );
};
